import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Future feature: Alert type imports
// import { Alert, SeverityLevel, Status } from '../../shared/types/types.js';
import { CollectiveIntelligence } from '../../types/collectiveIntelligence';

// Collective Intelligence Types are now imported from '../../types/collectiveIntelligence'

interface AlertFilters {
  severity: string[];
  status: string[];
  timeRange: {
    start: string | null;
    end: string | null;
  };
  tags: string[];
  assignedTo: string[];
}

interface AlertsState {
  filters: AlertFilters;
  selectedAlertId: string | null;
  sortBy: 'severity' | 'timestamp' | 'status';
  sortDirection: 'asc' | 'desc';
  // NEW: Collective intelligence data
  collectiveData: Record<string, CollectiveIntelligence>;
  collectiveLoading: boolean;
}

const initialState: AlertsState = {
  filters: {
    severity: [],
    status: [],
    timeRange: {
      start: null,
      end: null,
    },
    tags: [],
    assignedTo: [],
  },
  selectedAlertId: null,
  sortBy: 'timestamp',
  sortDirection: 'desc',
  // NEW: Collective intelligence initial state
  collectiveData: {},
  collectiveLoading: false,
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setSeverityFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.severity = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.status = action.payload;
    },
    setTimeRange: (state, action: PayloadAction<AlertsState['filters']['timeRange']>) => {
      state.filters.timeRange = action.payload;
    },
    setTagsFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.tags = action.payload;
    },
    setAssignedToFilter: (state, action: PayloadAction<string[]>) => {
      state.filters.assignedTo = action.payload;
    },
    setSelectedAlert: (state, action: PayloadAction<string | null>) => {
      state.selectedAlertId = action.payload;
    },
    setSortBy: (state, action: PayloadAction<AlertsState['sortBy']>) => {
      state.sortBy = action.payload;
    },
    toggleSortDirection: (state) => {
      state.sortDirection = state.sortDirection === 'asc' ? 'desc' : 'asc';
    },
    clearFilters: (state) => {
      state.filters = initialState.filters;
    },
    // NEW: Collective intelligence reducers
    setCollectiveData: (state, action: PayloadAction<Record<string, CollectiveIntelligence>>) => {
      state.collectiveData = action.payload;
      state.collectiveLoading = false;
    },
    setCollectiveLoading: (state, action: PayloadAction<boolean>) => {
      state.collectiveLoading = action.payload;
    },
    updateAlertCollectiveData: (state, action: PayloadAction<{ alertId: string; data: CollectiveIntelligence }>) => {
      state.collectiveData[action.payload.alertId] = action.payload.data;
    },
  },
});

export const {
  setSeverityFilter,
  setStatusFilter,
  setTimeRange,
  setTagsFilter,
  setAssignedToFilter,
  setSelectedAlert,
  setSortBy,
  toggleSortDirection,
  clearFilters,
  // NEW: Collective intelligence actions
  setCollectiveData,
  setCollectiveLoading,
  updateAlertCollectiveData,
} = alertsSlice.actions;

export default alertsSlice.reducer;
